import { Link } from 'react-router-dom'

export default function BackButton() {
    return <Link to="/menu" className="text-sm font-semibold leading-6 text-white mx-auto text-center mt-12 block">
        Volver al menú
    </Link>
}